import React, { CSSProperties } from 'react';

interface SvgIconUnderProps {
  style?: CSSProperties;
  color?: string;
}

const SvgIconUnder: React.FC<SvgIconUnderProps> = ({ color, style }) => {
  const iconFillColor = color || '#292929';
  return (
    <svg
      width='12'
      height='16'
      viewBox='0 0 12 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M0.857143 16C0.614286 16 0.410714 15.9148 0.246429 15.7444C0.0821429 15.5741 0 15.363 0 15.1111C0 14.8593 0.0821429 14.6481 0.246429 14.4778C0.410714 14.3074 0.614286 14.2222 0.857143 14.2222H11.1429C11.3857 14.2222 11.5893 14.3074 11.7536 14.4778C11.9179 14.6481 12 14.8593 12 15.1111C12 15.363 11.9179 15.5741 11.7536 15.7444C11.5893 15.9148 11.3857 16 11.1429 16H0.857143ZM6 12.4444C4.55714 12.4444 3.43571 11.9778 2.63571 11.0444C1.83571 10.1111 1.43571 8.87407 1.43571 7.33333V1.13333C1.43571 0.822222 1.54643 0.555556 1.76786 0.333333C1.98929 0.111111 2.25 0 2.55 0C2.85 0 3.10714 0.111111 3.32143 0.333333C3.53571 0.555556 3.64286 0.822222 3.64286 1.13333V7.46667C3.64286 8.2963 3.84286 8.97037 4.24286 9.48889C4.64286 10.0074 5.22857 10.2667 6 10.2667C6.77143 10.2667 7.35714 10.0074 7.75714 9.48889C8.15714 8.97037 8.35714 8.2963 8.35714 7.46667V1.13333C8.35714 0.822222 8.46786 0.555556 8.68929 0.333333C8.91071 0.111111 9.17143 0 9.47143 0C9.77143 0 10.0286 0.111111 10.2429 0.333333C10.4571 0.555556 10.5643 0.822222 10.5643 1.13333V7.33333C10.5643 8.87407 10.1643 10.1111 9.36429 11.0444C8.56429 11.9778 7.44286 12.4444 6 12.4444Z'
        fill={iconFillColor}
      />
    </svg>
  );
};

export default SvgIconUnder;
